<h2 mat-dialog-title>{{ 'common.password-confirmation.title' | exp:'':'Confirmar identidad' }}</h2>
        <form [formGroup]="form" (ngSubmit)="confirm()" [attr.aria-busy]="verifying">
            <mat-dialog-content>
                <app-password-input
                    [form]="form" name="password" [readonly]="verifying"
                    [label]="'common.password-confirmation.password' | exp:'':'Contraseña'">
                </app-password-input>
                <p *ngIf="error" class="verification-error" role="alert">{{ error }}</p>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-button type="button" (click)="cancel()" [disabled]="verifying">
                    {{ 'common.cancel' | exp:'':'Cancelar' }}
                </button>
                <button mat-flat-button color="primary" type="submit" [disabled]="verifying || form.invalid">
                    <mat-spinner *ngIf="verifying" diameter="18"></mat-spinner>
                    {{ 'common.confirm' | exp:'':'Confirmar' }}
                </button>
            </mat-dialog-actions>
        </form>
